<script>
export const group = 'Full'
</script>

<script setup>
import { colors } from '../../../tailwindTheme.config.js'
import AnimatedBackground from '../../AnimatedBackground.vue'
import ToFullBottomRight from './transitions/energetic_frequencies/ToFullBottomRight.vue'
import PositiveWaveLoop1 from '../../../assets/animations/energetic_frequencies/loops/positive_wave_loop_1.json'
import ArticleFull from './shared/ArticleFull.vue'

const props = defineProps({
  item: Object,
})

const schemes = [
  { backgroundColor: colors.q.cr.red.primary, color: colors.q.cr.red.darker },
  { backgroundColor: colors.q.cr.gray.primary, color: colors.q.cr.gray.darker },
]

// This is a temporary solution to prevent the same color scheme from being used twice in a row.
// A more proper background color scheme selection (including logo color picking) should be implemented in the future.
const schemeIndex = ((window.lastUsedSchemeIndex ?? 1) + 1) % schemes.length
window.lastUsedSchemeIndex = schemeIndex

const scheme = schemes[schemeIndex]

const subtitle = computed(() => {
  if (!props.item.enrichment.message.from?.name) {
    return ''
  }
  if (!props.item.enrichment.message.message && props.item.enrichment.message.image) {
    return `${props.item.enrichment.message.from.name} stuurt een foto via de Q-app`
  }
  return `${props.item.enrichment.message.from.name} stuurt via de Q-app`
})

const messageBoxElement = ref(null)
onMounted(() => {
  // Round height of messageBoxElement up to a whole number, to fix alignment of triangle
  messageBoxElement.value.style.height = `${Math.ceil(messageBoxElement.value.offsetHeight)}px`
})
</script>

<template>
  <ToFullBottomRight>
    <AnimatedBackground :lottie="PositiveWaveLoop1" :backgroundColor="scheme.backgroundColor" :color="scheme.color">
      <div class="px-32 flex flex-col justify-center h-full">
        <div ref="messageBoxElement" class="bg-white/80 p-5 rounded-[6rem] relative">
          <ArticleFull
            :title="subtitle"
            :imageUrl="item.enrichment.message.image"
            subtitle="Bericht"
            class="!text-q-cr-gray-primary !p-12"
            titleClass="!text-6xl"
            subtitleClass="font-bold !text-4xl bg-q-cr-red-primary inline-block px-6 py-1 rounded-full text-white"
          >
            {{ item.enrichment.message.message }}
          </ArticleFull>
          <div class="absolute -bottom-24 right-32 bg-white/80 size-24" :style="{ clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 0%)' }" />
        </div>
      </div>
    </AnimatedBackground>
  </ToFullBottomRight>
</template>
